export const CATEGORY_SOURCES = {
    EXPANSION_KITS: 'expansion-kits',
    CODABLE_KITS: 'codable-kits',
}

const LEGACY_MATCHERS = [
    {
        source: CATEGORY_SOURCES.EXPANSION_KITS,
        slug: 'expansion-kits',
        title: 'Expansion Kits',
    },
    {
        source: CATEGORY_SOURCES.CODABLE_KITS,
        slug: 'codable-kits',
        title: 'Codable Kits',
    },
]

const KNOWN_SOURCES = new Set(Object.values(CATEGORY_SOURCES))

export function getCategorySource(category) {
    if (!category) return null
    if (category.source) {
        return KNOWN_SOURCES.has(category.source) ? category.source : null
    }
    const title = category.title || category.display_name
    const match = LEGACY_MATCHERS.find(
        (m) => category.slug === m.slug || title === m.title
    )
    return match ? match.source : null
}

export function isCategoryFromSource(category, source) {
    return getCategorySource(category) === source
}
